import { type LoaderFunctionArgs } from "react-router";

import {
  PromptBlockRefDocument,
  type PromptBlockRefQuery,
  type PromptBlockRefQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

import { requireParam } from "@application/hooks/use_required_param";

// Just enough for the breadcrumbs; the pages load their own details.
export const DASHBOARD_PROMPT_BLOCK_REF_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const { data } = await client.query<
    PromptBlockRefQuery,
    PromptBlockRefQueryVariables
  >({
    query: PromptBlockRefDocument,
    variables: {
      name: requireParam(props.params, "name"),
      version: props.params.version,
    },
  });

  return data;
};
